import { render, staticRenderFns } from "./NameAndValueTpl.vue?vue&type=template&id=5c4e334f&"
import script from "./NameAndValueTpl.vue?vue&type=script&lang=js&"
export * from "./NameAndValueTpl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports